import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import CallexLoader from '../../../components/CallexLoader';
import Pagination from '../../../components/form/Pagination';
import { checkModulePermission } from '../../../utils/common';
import AdminHeader from '../../../components/header/AdminHeader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  hotkeyListGet,
  useHotkeyList,
  hotkeyDelete
} from '../../../store/slices/tenantSlices/configurationSlice';
import { useUserRolePermission } from '../../../store/slices/authSlice';
import AddEditHotKeyModal from './AddEditHotKeyModal';

const HotKey = () => {
  const dispatch = useDispatch();
  const hotkeyList = useHotkeyList();
  const userRolePermission = useUserRolePermission();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: undefined
  });

  const fetchHotkeyList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(hotkeyListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteHotkey = async () => {
    try {
      const response = await dispatch(hotkeyDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        if (hotkeyList?.data?.length === 1) {
          setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        } else {
          fetchHotkeyList();
        }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchHotkeyList();
  }, [filter]);

  return (
    <div>
      <AdminHeader
        title="Hot Key"
        isExpandSearch
        isAdd
        onAddClick={() => setOpenAddModal(true)}
        isAddDisabled={!checkModulePermission('is_add', 'Hot Key', userRolePermission)}
        addBtnName="Add Hot Key"
        searchPlaceholder="Search Hot Key"
        search={filter.search}
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          <CallexLoader />
        </Card>
      ) : hotkeyList?.data?.length > 0 &&
        checkModulePermission('is_view', 'Hot Key', userRolePermission) ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 210px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Hot Key</th>
                  <th>Hot Key Number</th>
                  <th className="text-center" style={{ width: '120px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {hotkeyList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.hot_key}</td>
                      <td>{val?.hot_key_number}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div
                            className={`cursor-pointer text-info ${
                              !checkModulePermission('is_edit', 'Hot Key', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_edit', 'Hot Key', userRolePermission)
                                ) {
                                  setEditRecord(val);
                                  setIsEdit(true);
                                  setOpenAddModal(true);
                                }
                              }}
                            />
                          </div>
                          <div
                            className={`cursor-pointer text-danger ${
                              !checkModulePermission('is_delete', 'Hot Key', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_delete', 'Hot Key', userRolePermission)
                                ) {
                                  setIsDeleteId(val?.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="position-absolute w-100" style={{ bottom: '-56px' }}>
            <Pagination
              totalCount={hotkeyList?.total}
              limit={hotkeyList?.limit}
              page={hotkeyList?.page}
              onLimitChange={(val) => {
                setFilter({ ...filter, page: 1, limit: val });
              }}
              onPageClick={(val) => setFilter({ ...filter, page: val })}
              lastPageClick={(val) => setFilter({ ...filter, page: val })}
              firstPageClick={(val) => setFilter({ ...filter, page: val })}
              onRefreshClick={() => fetchHotkeyList()}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteHotkey()}
      />
      <AddEditHotKeyModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            fetchHotkeyList();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
    </div>
  );
};

export default HotKey;
